import { AnchorButton, Button, Intent, Tooltip } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { segmentTrackClickCustomUpgradesLocked } from "in_queue/analytics";
import { useCluster } from "in_queue/contexts/ClusterContext";
import { useCustomUpgradesStatus } from "in_queue/hooks/useCustomUpgradesStatus";
import { CUSTOM_UPGRADES_LOCKED_MESSAGE } from "in_queue/utils/customUpgradesStatus";
import { useState } from "react";
import { ADMIN_TYPE } from "types/roleType";
import { AddCustomUpgradesDialog } from "./AddCustomUpgradesDialog";

export const AddCustomUpgradeButton: React.FC = () => {
    const { role } = useUserDataContext();
    const cluster = useCluster();
    const status = useCustomUpgradesStatus();
    const [dialogOpen, setDialogOpen] = useState(false);

    if (role !== ADMIN_TYPE) return null;

    // Add-on not unlocked: show the entry point disabled with the upsell
    // tooltip (AnchorButton so the tooltip fires while disabled).
    if (status === "locked") {
        return (
            <Tooltip
                content={CUSTOM_UPGRADES_LOCKED_MESSAGE}
                targetProps={{
                    onClick: () =>
                        segmentTrackClickCustomUpgradesLocked(cluster)
                }}
            >
                <AnchorButton
                    intent={Intent.PRIMARY}
                    icon={IconNames.ADD}
                    text="Add Portfolio Upgrade"
                    disabled
                />
            </Tooltip>
        );
    }

    const closeDialog = () => setDialogOpen(false);
    const openDialog = () => setDialogOpen(true);
    return (
        <>
            <Button
                intent={Intent.PRIMARY}
                icon={IconNames.ADD}
                text="Add Portfolio Upgrade"
                onClick={openDialog}
            />
            {dialogOpen && (
                <AddCustomUpgradesDialog
                    isOpen={dialogOpen}
                    onClose={closeDialog}
                />
            )}
        </>
    );
};
